import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, HashRouter } from 'react-router-dom';
import { TonConnectUIProvider } from '@tonconnect/ui-react';
import { App } from './App';
import { AutomatonProvider } from './state/AutomatonContext';
import './styles/globals.css';

const manifestUrl =
  import.meta.env.VITE_TONCONNECT_MANIFEST_URL ?? '/tonconnect-manifest.json';

const params = new URLSearchParams(window.location.search);
const seed = params.get('fresh') === '1' ? String(Date.now()) : 'automaton-v1';

// HashRouter for file:// previews and zero-config Vercel; switch to BrowserRouter
// once a server with SPA fallback is in front of the bundle.
const isFile = window.location.protocol === 'file:';
const Router = isFile ? HashRouter : BrowserRouter;

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <TonConnectUIProvider manifestUrl={manifestUrl}>
      <Router>
        <AutomatonProvider seed={seed}>
          <App />
        </AutomatonProvider>
      </Router>
    </TonConnectUIProvider>
  </React.StrictMode>
);
